import React from 'react'
import OProject3 from '../assets/projects/OProject3.jpg'
import NID from '../assets/projects/NID.jpg'
import AparnaSarovar from '../assets/projects/aparnaSarovar.jpg'
import Allura from '../assets/projects/allura.jpg'
import SMRVinay from '../assets/projects/smrVinay.jpg'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faThumbtack, faExclamationTriangle } from '@fortawesome/free-solid-svg-icons';
import { Link } from 'react-router-dom'

class OnGoingProjects extends React.Component{

    constructor(props){
        super(props);
        this.state = {
            onGoingProjects: [
                // {id: 2, image: OProject2, title: 'Bonsai homes' , location: 'Tellapur', date: 'Under Process'},
                {id: 1, image: OProject3, title: 'Northstar Homes District 1' , location: 'Financial District', date: 'Under Process'},
                {id: 2, image: NID, title: 'National Institute of Design (NID)' , location: 'Vijayawada', date: 'Under Process'},
                {id: 3, image: AparnaSarovar, title: 'Aparna Sarovar zenith' , location: 'Nallagandla', date: 'Under Process'},
                {id: 4, image: Allura, title: 'Allura luxury villas' , location: 'Kokapet', date: 'Under Process'},
                {id: 5, image: SMRVinay, title: 'SMR Vinay Casa Carino' , location: 'Bandlaguda', date: 'Under Process'},
            ]
        }
    }

    render(){
        return(
            <div>
                <section className="md:px-10 px-2 bg-pink-100 bg-opacity-75">
                    <div className="grid grid-cols-12 py-10 gap-6 ">
                        <div className="col-span-12">
                            <h2 className="text-xl text-yellow-700 px-10 py-2 rounded shadow bg-yellow-100 capitalize font-bold"><FontAwesomeIcon icon={faExclamationTriangle} className="text-yellow-600 mr-2" />On Going Projects</h2>
                        </div>
                            {
                                this.state.onGoingProjects.map(function (projects){
                                    return(
                                        <div className="col-span-12 md:col-span-3">
                                            <div className="card h-full border border-gray-400 hover:shadow-2xl overflow-hidden bg-white rounded-lg relative">
                                                <img src={projects.image} alt={projects.title}/>
                                                <div className="absolute top-0 right-0 w-12 h-12 flex items-center justify-center p-2 rounded-full bg-as font-bold text-2xl text-white m-5 border-2 border-white">{projects.id}</div>
                                                <div className="card-body p-5">
                                                    <p className="text-xl font-semibold tracking-tight">{projects.title}</p>
                                                    <div className="flex items-center justify-between mt-5">
                                                        <p className="text-base w-75"><FontAwesomeIcon className="mr-2  text-pink-600 "  icon={faThumbtack} />{projects.location}</p>
                                                        <p className="text-base"><FontAwesomeIcon  className="mr-2 text-pink-600 " icon={faExclamationTriangle} />{projects.date}</p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    )
                                })
                            }
                        </div>
                </section>
            </div>
        )
    }
}

export default OnGoingProjects;


// WEBPACK FOOTER //
// ./src/components/onGoingProjects.jsx